import { Link } from "@tanstack/react-router";
import { useOptionalConsent } from "./ConsentContext";
import { ConsentSettingsDialog } from "./ConsentSettingsDialog";

export function CookieBanner() {
  const consent = useOptionalConsent();

  if (!consent) return null;

  const { state, ready, acceptAll, rejectAll, openSettings, isSettingsOpen } = consent;

  // Erst nach Client-Hydration entscheiden — verhindert SSR/Hydration-Mismatch.
  const showBanner = ready && state === null;

  return (
    <>
      {showBanner && (
        <div
          role="dialog"
          aria-modal="false"
          aria-labelledby="consent-banner-title"
          aria-describedby="consent-banner-desc"
          className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background shadow-[0_-8px_30px_rgba(0,0,0,0.08)]"
        >
          <div className="mx-auto flex max-w-6xl flex-col gap-5 px-6 md:px-12 py-6 md:flex-row md:items-start md:justify-between md:gap-8">
            <div className="max-w-2xl">
              <p
                id="consent-banner-title"
                className="font-display text-lg font-extrabold text-primary"
              >
                Wir respektieren Ihre Privatsphäre
              </p>
              <p
                id="consent-banner-desc"
                className="mt-2 font-body text-sm leading-relaxed text-foreground"
              >
                Wir nutzen Cookies: essenziell für den Betrieb, mit Ihrer Einwilligung auch
                für eingebettete Inhalte, Statistik und Marketing. Dabei können Daten in die
                USA übertragen werden. Ihre Einwilligung ist freiwillig und jederzeit im
                Footer widerrufbar. Details:{" "}
                <button
                  type="button"
                  onClick={openSettings}
                  className="underline underline-offset-4 hover:text-primary"
                >
                  Einstellungen
                </button>
                ,{" "}
                <Link to="/datenschutz" className="underline underline-offset-4 hover:text-primary">
                  Datenschutzerklärung
                </Link>
                ,{" "}
                <Link to="/impressum" className="underline underline-offset-4 hover:text-primary">
                  Impressum
                </Link>
                .
              </p>
            </div>

            <div className="flex flex-col gap-2 md:min-w-[220px]">
              <button
                type="button"
                onClick={acceptAll}
                className="inline-flex h-10 items-center justify-center rounded-md bg-brand-button px-4 text-sm font-extrabold text-brand-button-foreground transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                Alle akzeptieren
              </button>
              <button
                type="button"
                onClick={rejectAll}
                className="inline-flex h-10 items-center justify-center rounded-md border border-input bg-background px-4 text-sm font-extrabold text-foreground transition-colors hover:bg-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                Alle ablehnen
              </button>
              <button
                type="button"
                onClick={openSettings}
                className="inline-flex h-10 items-center justify-center rounded-md px-4 text-sm font-extrabold text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                Einstellungen
              </button>
            </div>
          </div>
        </div>
      )}

      {isSettingsOpen && <ConsentSettingsDialog />}
    </>
  );
}
